import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IcoClose from 'components/icons/iconClose';
const IconClose = t0 => {
  const $ = _c(8);
  let props;
  let svgProps;
  if ($[0] !== t0) {
    ({
      svgProps,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = svgProps;
  } else {
    props = $[1];
    svgProps = $[2];
  }
  let t1;
  if ($[3] !== svgProps) {
    t1 = <IcoClose {...svgProps} />;
    $[3] = svgProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div id="flex items-center justify-center bg-transparent border border-solid [border-color:#dedede] cursor-pointer h-[45px] w-[45px] rounded-full hover:border-brand [&_svg]:w-3.5 [&_svg]:h-3.5 [&_svg]:!m-0 [&_svg_path]:fill-gray" {...props}>{t1}</div>;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
IconClose.propTypes = {
  svgProps: PropTypes.objectOf(PropTypes.object)
};
export default IconClose;